import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { ConceBeneficiary, ConceBeneficiaryRes, Concessionaire, DatatableRootObject, DataTablesResponse, PagedList, UploadDataResult } from '../interfaces/interfaces.index';
import { UploadFile } from '../shared/upload/upload.component';
const URL = `${URL_SERVICIOS}concessionaire`;

@Injectable({
  providedIn: 'root'
})
export class ConcessionaireService {

  constructor(private http: HttpClient) { }

  getConcessionaireDataTable = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Concessionaire>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);

  getAllConcessionaire = () => this.http.get<Concessionaire[]>(URL);

  getConcessionaire = (id: number) => this.http.get<Concessionaire>(`${URL}/${id}`);

  addConcessionaire = (data: Concessionaire) => this.http.post<Concessionaire>(URL, JSON.stringify(data), HTTP_OPTIONS);

  deleteConcessionaire = (id: number) => this.http.delete(`${URL}/${id}`, HTTP_OPTIONS);

  putConcessionaire = (id: number, data: Concessionaire) => this.http.put(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);

  massiveConcessionaire = (file: UploadFile) => this.http.post<UploadDataResult>(`${URL}/file`, file, HTTP_OPTIONS);

  getInvoiceByPetition = (petitionId: number) => this.http.get<string>(`${URL}getAuthInvoice/${petitionId}`);

  getAllBeneficiaries = () => this.http.get<ConceBeneficiaryRes[]>(`${URL}/getAllBeneficiaries`, HTTP_OPTIONS);
}
